import Vue from 'vue';
import Router from 'vue-router';
import Intro from '@/components/Intro';
import BrowseEpisode from '@/components/BrowseEpisode';
import BrowseSeason from '@/components/BrowseSeason';
import RandomEpisode from '@/components/RandomEpisode';
import DrinkingRules from '@/components/DrinkingRules';
import checkWithin from '../lib/checkWithin';

const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    name: 'Intro',
    component: Intro
  },
  {
    name: 'random-season-episode',
    path: '/Random/Season/:seasonNumber/Episode/:episodeNumber',
    component: RandomEpisode,
    props: route => ({
      within: checkWithin(route.query.within || 'season'),
      seasonNumber: route.params.seasonNumber,
      episodeNumber: route.params.episodeNumber
    })
  },
  {
    path: '/Browse/Season/:seasonNumber',
    component: BrowseSeason,
    props: true
  },
  {
    path: '/Browse/Season/:seasonNumber/Episode/:episodeNumber',
    component: BrowseEpisode,
    props: true
  },
  {
    path: '/DrinkingRules',
    component: DrinkingRules
  }
];

Vue.use(Router);

export default new Router({
  routes
});



// WEBPACK FOOTER //
// ./src/router/index.js